// extracted by mini-css-extract-plugin
module.exports = {"SPEAKER_INNER_CLASS":"g_speaker_inner"};